define('plugin/package/view/PackageClientInstanceCollectionView',['require','lib/view/BaseCollectionView','plugin/package/view/PackageClientInstanceItemView','plugin/package/view/PackageInstanceEmptyView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var PackageClientInstanceItemView = require('plugin/package/view/PackageClientInstanceItemView');
    var PackageInstanceEmptyView = require('plugin/package/view/PackageInstanceEmptyView');

    /**
     * Package instance collection view
     *
     * @class PackageClientInstanceCollectionView
     */
    return Parent.extend({

        childView: PackageClientInstanceItemView,
        emptyView: PackageInstanceEmptyView,
        childViewOptions: function (model, index) {
            var highlighted = false;
            if (this.getOption('highlighted') && this.getOption('highlighted') == model.get('id')) {
                highlighted = true;
            }

            return {
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection'),
                highlighted: highlighted
            };
        },
        collectionEvents: {
            sync: 'render'
        },
        _pageId: 'package',

        initialize: function () {
            this.listenTo(this.getOption('serviceCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('productCollection'), 'sync', this.safeRender);
            this.listenTo(this.getOption('attributeCollection'), 'sync', this.safeRender);

            Parent.prototype.initialize.apply(this, arguments);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onDomRefresh: function () {
            Parent.prototype.onDomRefresh.apply(this);
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'my_packages'
            });
        }

    });

});
